import {Component, Inject, OnInit, ViewEncapsulation, ViewContainerRef} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {Router} from '@angular/router';
import {ApiService} from '../shared/services/api.service';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {HttpClient} from '@angular/common/http';
import {CookieService} from "ngx-cookie-service";
import {InternalService} from "../shared/services/internal.service";
import {any} from "codelyzer/util/function";

@Component({
  selector: 'app-notFound',
  templateUrl: './notFound.component.html',
  styleUrls: ['./notFound.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NotFoundComponent implements OnInit {


  constructor(private translateModule: TranslateService, @Inject(SESSION_STORAGE) private session: WebStorageService,
              private router: Router,
              public apiService: ApiService,
              public internalService: InternalService,
              public translate: TranslateService,
              private cookieService: CookieService,
              public oidcSecurityService: OidcSecurityService, public http: HttpClient,) {

    if (this.cookieService.get('lang') === undefined) {
      this.cookieService.set('lang', '1');
    }
  }

  ngOnInit() {

  }

  LogOut() {
    const url = this.oidcSecurityService.getEndSessionUrl()
    this.oidcSecurityService.logoffLocal()
    this.cookieService.delete('fullName')
    this.cookieService.delete('currentUserRoles');
    window.location.assign(url)
    this.oidcSecurityService.logoff((url: 'https://mac.medis.land/account/logout') => any);

  }


}

